import { actionTypes } from "../../../../constants/Reports/index";

export const setDateToState = filters => dispatch => {
  dispatch({
    type: actionTypes.SET_FILTERS,
    payload: filters
  });
};
